import { useState } from 'react';

import { useAtomValue } from 'jotai';

import { postcodeAtom } from '@core/Atoms/Postcode/Postcode.atom';
import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { locationAtom } from '@core/Atoms/Search/LocationAtom';
import Button from '@gds/Button/Button';
import { useSearchWidgetTracking } from '@search/Hooks/UseSearchWidgetTracking';

import { locationAggregationsAtom } from '../../Atoms/LocationAggregationAtom/LocationAggregationAtom';
import type { SearchCTAProps } from '../../Search.entity';

const SearchCTA = ({
  searchButton,
  loadingText,
  disabled,
  showLoadingCta,
  isLocationPage = false,
  searchUrl,
}: SearchCTAProps) => {
  const { totalCount = 0, isLoading } = useAtomValue(
    isLocationPage ? locationAggregationsAtom : aggregationsAtom,
  ) as { totalCount: number; isLoading: boolean };
  const postcode = useAtomValue(postcodeAtom);
  const { isValid } = useAtomValue(locationAtom);
  const [shouldShowLoader, setShouldShowLoader] = useState(false);

  const { trackSubmitCta } = useSearchWidgetTracking(searchUrl, searchButton);

  const buttonText = isLoading ? loadingText : searchButton;
  const isButtonDisabled = isLocationPage ? disabled : totalCount === 0 || disabled;

  const handleClick = () => {
    if ((isValid && !!postcode.uk) || showLoadingCta) {
      setShouldShowLoader(true);
    }
    trackSubmitCta();
  };

  return (
    <Button
      fullWidth
      variant="contained"
      aria-label="search-button"
      onClick={handleClick}
      disabled={isButtonDisabled}
      loading={shouldShowLoader}
      type="submit"
      data-test-id="search-button"
    >
      {buttonText}
    </Button>
  );
};

export default SearchCTA;
